import startCase from "lodash/startCase";
import { limitLengthName } from "@/app/ui/modules/receipt-v2/module";
import {
  MultilingualText,
  renderMultilingualText
} from "../../../../../infrastructures/misc/js-pdf copy/render-multilingual-text";

export const DeliverySenderReceiverSection = async (
  params: any,
  translate: Function
) => {
  const leftMargin = params.startX + 5;
  params.doc.setTextColor("#333333");

  const product = params.data.sttProductType;
  const maxWidth = 70;
  const senderTopGap = 4;
  const senderRecipientGap = 3;

  // ======================
  // SENDER
  // ======================
  const senderPositionY = params.startY + 40 + senderTopGap;

  const sttSenderNameData = limitLengthName(params.data.sttSenderName, 60);

  const sttSenderText =
    startCase(translate("receipt.shipper")).toUpperCase() +
    ": " +
    sttSenderNameData.toUpperCase() +
    " " +
    params.data.sttSenderPhone;

  const senderBlock = await renderMultilingualText(
    new MultilingualText({
      doc: params.doc,
      text: sttSenderText,
      product,
      startX: leftMargin,
      startY: senderPositionY,
      maxWidth,
      fontStyle: "bold",
      fontSize: 6
    })
  );

  // ======================
  // RECEIVER
  // ======================
  const recipientPositionY =
    senderPositionY + senderBlock.height + senderRecipientGap;

  const sttRecipientName = limitLengthName(params.data.sttRecipientName, 85);

  const sttRecipientText =
    startCase(translate("receipt.receiver")).toUpperCase() +
    ": " +
    sttRecipientName.toUpperCase();

  const recipientBlock = await renderMultilingualText(
    new MultilingualText({
      doc: params.doc,
      text: sttRecipientText,
      product,
      startX: leftMargin,
      startY: recipientPositionY,
      maxWidth,
      fontStyle: "bold",
      fontSize: 6
    })
  );

  return {
    senderPositionY,
    recipientPositionY,
    recipientHeight: recipientBlock.height,
    recipientRowText: recipientBlock.rowText
  };
};
